import confetti from 'canvas-confetti';
/**
 * Helpers de célébration visuels. Tous respectent prefers-reduced-motion :
 * si l'utilisateur a coché "réduire les animations", on no-op.
 */
function reducedMotion() {
    if (typeof window === 'undefined' || !window.matchMedia)
        return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
/** Confettis classiques (podium 1er, level-up). */
export function celebrateBurst() {
    if (reducedMotion())
        return;
    confetti({
        particleCount: 120,
        spread: 80,
        origin: { y: 0.6 },
        colors: ['#FFD700', '#F97316', '#3B82F6', '#8B5CF6', '#FACC15'],
    });
}
/** Cascade plus longue pour les podiums multi (cérémonie). */
export function celebrateCascade() {
    if (reducedMotion())
        return;
    const end = Date.now() + 1_500;
    const interval = window.setInterval(() => {
        if (Date.now() > end) {
            window.clearInterval(interval);
            return;
        }
        confetti({
            particleCount: 50,
            angle: 60,
            spread: 55,
            origin: { x: 0, y: 0.7 },
            colors: ['#FFD700', '#C0C0C0', '#CD7F32'],
        });
        confetti({
            particleCount: 50,
            angle: 120,
            spread: 55,
            origin: { x: 1, y: 0.7 },
            colors: ['#FFD700', '#C0C0C0', '#CD7F32'],
        });
    }, 200);
}
/** Mini-burst doré pour les achievements légendaires. */
export function celebrateLegendary() {
    if (reducedMotion())
        return;
    confetti({
        particleCount: 80,
        spread: 100,
        startVelocity: 35,
        origin: { y: 0.4 },
        colors: ['#FFD700', '#FFB800', '#FFEC8B', '#F97316'],
        shapes: ['star', 'circle'],
    });
}
/** Petit pop pour level-up. */
export function celebrateLevelUp() {
    if (reducedMotion())
        return;
    confetti({
        particleCount: 60,
        spread: 60,
        startVelocity: 25,
        origin: { x: 0.92, y: 0.08 }, // coin haut-droit, vers l'avatar
        colors: ['#3B82F6', '#60A5FA', '#FACC15'],
    });
}
